import React from 'react';
import { Button, Header } from 'semantic-ui-react';

const ACCOUNT = {account_id: '00D41000001PZOl', org_name: "Customer Success"};

const Migrate = ({ firstStep }) => (
  <React.Fragment>
    <Header as="h3">Successfully migrated account: {ACCOUNT.org_name}</Header>
    <Button onClick={firstStep}>Migrate Another</Button>
  </React.Fragment>
);

export default {
  title: 'Success',
  description: 'Migration successful',
  icon: 'check',
  component: Migrate,
};
